module.exports = __webpack_public_path__ + "static/media/pdf.eeef9c24.png";